import { Navigate, useParams } from 'react-router-dom';

// A customer-dashboard path retired by PRD v2.5 §7.3.2 that must keep resolving —
// bookmarks, notification deep links, SMS links and the website's account menu still
// point at them (copy of website/src/shell/retired-route.tsx, per surface by CB-D12):
//   /profile          → /account                    (route 7 replaces /profile)
//   /notifications    → /  with the tray open       (FR-C28, DR-38)
//   /bookings/:code   → /bookings?b=:code            (the booking opens inside My bookings)
// `replace` so the retired URL does not sit in history — Back would bounce straight
// back into the redirect. `state` rides along for the tray request.
export function RetiredRoute({
  to,
  carryParam,
  as,
  state,
}: {
  to: string;
  /** Route param to carry across, e.g. the booking code. */
  carryParam?: string;
  /** Query key it becomes on the destination. */
  as?: string;
  /** Navigation state handed to the destination (e.g. `{ tray: true }`). */
  state?: Record<string, unknown>;
}) {
  const params = useParams();
  const value = carryParam ? params[carryParam] : undefined;
  const target = value && as ? `${to}?${as}=${encodeURIComponent(value)}` : to;
  return <Navigate to={target} replace state={state} />;
}
